// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__hQ5xe","buttons":"styles_buttons__29E0n"};